module.exports = __webpack_public_path__ + "img/no-avatar.c3db7066.svg";